export default __webpack_public_path__ + "static/media/colorLogo.b65e1635.svg";